import { useEffect } from "react";

const ATTRS: Record<string, string> = {
  "data-id": "a4uzpiEb8mkvkDmM-ct2iMSh_Bkq0dukWTfyhRtw9JVQ3A",
  "data-country-code": "NL",
  "data-language-code": "nl",
  "data-main-language": "nl",
  "data-bot-name": "Sam",
  "data-avatar-color": "#1F6FEB",
  "data-primary-color": "#FF7D5D",
  "data-launcher-icon": "chat_filled",
  "data-enable-callback": "true",
  "data-enable-whatsapp": "true",
  "data-enable-quote": "true",
  "data-enable-appointment": "false",
  "data-enable-ai": "true",
  "data-quote-fields": "name,phone,email,project,postal",
  "data-welcome-message": "Hoi! ik ben Sam, de virtuele assistent van Vakkundig Verhuizingen & Transport. Hoe kan ik u helpen?",
  "data-teaser-enabled": "true",
  "data-teaser-text": "Heb je vragen? Ik help je graag verder!",
  "data-auto-open": "true",
  "data-auto-open-delay": "10",
  "data-knowledge": "Vraag altijd naar het volgende als men over ''verhuizen'', ''verhuis'', ''hulp nodig met verhuizing'', ''ik wil verhuizen'' en ''verhuisbedrijf'' begint:\n\n* Verhuisdatum\n* Het startadres\n* Het eindadres\n* De verdieping in geval van appartement\n* De te verhuizen inboedel (graag inclusief afmetingen),  In geval van kledingkasten: graag het aantal deuren vermelden en eventuele bijzonderheden, zoals ingebouwde verlichting, spiegels, schuifdeuren of maatwerkconstructies\n* Het aantal verhuisdozen\n* Of u hulp nodig heeft met:\n- Demonteren en monteren van meubels\n- Het afhalen van lampen of gordijnen\n- Het afkoppelen van de wasmachine en/of droger\n\nBij het aangeven van deze gegevens, kunnen wij een offerte voor u opstellen.\n\n\nVraag altijd naar het volgende als men over ''transport'', ''verhuislift'', 'een meubelstuk'', ''1 meubelstuk'' begint:\n\n* gaat om meer dan 1 meubelstuk?\n* wilt u alleen een verhuislift huren of volledig hulp met verhuizen? \n* Verhuisdatum\n* Het startadres\n* Het eindadres\n* De verdieping in geval van appartement\n",
  "data-tone": "friendly",
  "data-address-form": "u",
  "data-auto-init": "true"
};

export function TrustooChat() {
  useEffect(() => {
    if (document.getElementById("trustoo-chatbot-js")) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://chatbot-widget.trustoo.nl/trustoo-chatbot.css";
    document.head.appendChild(link);
    const script = document.createElement("script");
    script.id = "trustoo-chatbot-js";
    script.src = "https://chatbot-widget.trustoo.nl/trustoo-chatbot.iife.js";
    for (const [k, v] of Object.entries(ATTRS)) script.setAttribute(k, v);
    document.body.appendChild(script);
  }, []);
  return null;
}
